import React from 'react';
import { Box, Typography, Divider, Grid } from '@mui/material';
import { glossaryTerms } from '../../data/glossary';

export const Glossary: React.FC = () => {
  // Sort terms alphabetically
  const sortedTerms = [...glossaryTerms].sort((a, b) => 
    a.term.localeCompare(b.term)
  );

  return (
    <Box>
      <Typography variant="h2" gutterBottom>
        Glossary of Terms
      </Typography>
      <Typography variant="body2" sx={{ mb: 3 }}>
        This glossary provides definitions for common terms used in genetic reports.
      </Typography>
      
      <Grid container spacing={6}>
        <Grid item xs={6}>
          {sortedTerms.slice(0, Math.ceil(sortedTerms.length / 2)).map((item, index) => (
            <Box 
              key={item.term} 
              sx={{ 
                mb: 1.5,
                '&:last-child': { mb: 0 },
                pageBreakInside: 'avoid',
              }}
            >
              <Typography 
                variant="subtitle1" 
                component="dt" 
                sx={{ 
                  fontWeight: 500,
                  color: 'primary.main',
                  fontSize: '0.9rem'
                }}
              >
                {item.term}
              </Typography>
              <Typography 
                variant="body2" 
                component="dd" 
                sx={{ 
                  mt: 0.5,
                  ml: 0,
                  fontSize: '0.85rem',
                  color: 'text.secondary'
                }}
              >
                {item.definition}
              </Typography>
              {index < Math.ceil(sortedTerms.length / 2) - 1 && (
                <Divider sx={{ my: 1.5 }} light />
              )}
            </Box>
          ))}
        </Grid>
        <Grid item xs={6}>
          {sortedTerms.slice(Math.ceil(sortedTerms.length / 2)).map((item, index) => (
            <Box 
              key={item.term} 
              sx={{ 
                mb: 1.5,
                '&:last-child': { mb: 0 },
                pageBreakInside: 'avoid',
              }}
            >
              <Typography 
                variant="subtitle1" 
                component="dt" 
                sx={{ 
                  fontWeight: 500,
                  color: 'primary.main',
                  fontSize: '0.9rem'
                }}
              >
                {item.term}
              </Typography>
              <Typography 
                variant="body2" 
                component="dd" 
                sx={{ 
                  mt: 0.5,
                  ml: 0,
                  fontSize: '0.85rem',
                  color: 'text.secondary'
                }}
              >
                {item.definition}
              </Typography>
              {index < Math.floor(sortedTerms.length / 2) - 1 && (
                <Divider sx={{ my: 1.5 }} light />
              )}
            </Box>
          ))}
        </Grid>
      </Grid>
    </Box>
  );
};

export default Glossary; 